export default {
  /* Colors */
  alertBannerRed: '#cc1f3b',
  black: '#000000',
  blue: '#5396e2',
  darkRed: '#6d0909',
  grayDark: '#959595',
  grayDarker: '#555555',
  grayDarkest: '#333333',
  grayMedium: '#595959',
  grayLight: '#dddddd',
  linkColor: '#2d5ea8',
  offWhite: '#f3f3f3',
  transparent: 'rgba(255, 255, 255, 0)',
  white: '#fff',
  yellow: '#ffff00',
  /* Political Parties */
  democrat: '#375ea3',
  democratLight: '#ebf0f7',
  republican: '#bc3340',
  republicanLight: '#fae9ec',
  independent: '#999999',
  independentLight: '#E2E2E2',
  yes: '#3798a1',
  yesLight: '#9eced2',
  no: '#69518e',
  noLight: '#b7acc9',
  /* Fonts */
  fontAccent: '"Roboto Condensed", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif', // eslint-disable-line max-len
  fontPrimary: 'Arial, Helvetica, Verdana, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif', // eslint-disable-line max-len
  fontSourceSansPro: '"Source Sans Pro", Arial, Helvetica, Verdana, sans-serif',
  fontSourceSerifPro: '"Source Serif Pro", georgia, times, serif',
  /* Breakpoints */
  sm: '512px',
  md: '652px',
  lg: '1040px',
  xl: '1200px',
  /* Variables */
  borderColor: '#dddddd',
  imgHeight: '1.9375rem',
  rowHeight: '2.5rem',
};
